import { messages } from "./messages"
import { create as createI18nStore } from "./store"

export { default as defaultMessages } from "./default-messages.json"
export type { Messages } from "./messages"
export { REPLACEMENTS } from "./replacements"

export const t = createI18nStore(messages)
